import React from 'react';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

export const componentMainTitle = 'Healthy Deals';

export const minDoB = new Date(1900, 1, 1); // All birthdays need to be after this date.

export const cardsPerPage = 18;

export const componentMainDescription =
	'Discounts on products and services to help support your health and fitness journey.';

export const mockHealthyDealsDataContextProviderProps = {
	setMainTitleTo: componentMainTitle,
	redirectToResourceLibrary: () => {},
	redirectToLogin: () => {},
	redirectToNetworkSearch: () => {},
	updatePageTitleAndDescription: () => {},
	componentRootPath: '/home',
};

export const mockHealthyDealsProps = {
	apiEnvironment: 'dev',
	ssId: '',
	hpCode: '',
	hasOwnProvider: false,
	description: componentMainDescription,
};

export const contentfulOptions = {
	renderText: text =>
		text &&
		text
			.split('\n')
			.reduce(
				(children, textSegment, index) => [
					...children,
					index > 0 && <br key={textSegment} />,
					textSegment,
				],
				[],
			),
	renderNode: {
		table: (node, children) => (
			<TableContainer>
				<Table>
					<TableBody>{children}</TableBody>
				</Table>
			</TableContainer>
		),
		'table-row': (node, children) => <TableRow>{children}</TableRow>,
		'table-cell': (node, children) => <TableCell>{children}</TableCell>,
		'asset-hyperlink': node => (
			<Link href={node.data.target.file.url}>{node.data.target.title}</Link>
		),
		// Checking for empty string values before wrapping typography over contentful paragraph.
		paragraph: (_node, children) => {
			const nonEmptyChildren = children.filter(child => child);
			return (
				nonEmptyChildren.length > 0 && (
					<Typography>{nonEmptyChildren}</Typography>
				)
			);
		},
		// Adding break tags after each object for the contentful rich text document except for the last object
		document: (node, children) => {
			const nonEmptyObjects = children.filter(child => child);

			return nonEmptyObjects.map((child, index) => (
				// eslint-disable-next-line react/no-array-index-key
				<React.Fragment key={`index${index}`}>
					{child}
					{index < nonEmptyObjects.length - 1 && <br />}
				</React.Fragment>
			));
		},
	},
};

export const mainPageMetaDescription =
	'Discover exclusive health and wellness deals! Save on top brands and specialty services plus access to free health information. Prioritize your well-being today!';

export const afdPageMetaDescription =
	'Active&Fit Direct Membership details and how to enroll.';

export const vendorPageMetaDescription = title =>
	`${title} offer details and how to redeem.`;

export const specialtyPageMetaDescription = title =>
	`${title} offering and how to find a provider.`;
